import PaginationState from '../pagination/PaginationState'
import Page from '../pagination/Page'

import { Client as RevasClient } from '@revas/ts-api'

import { Resource } from '@/models'

export default class ListInfiniteResourcePagination extends PaginationState<Resource> {
  revasClient: RevasClient | null = null

  constructor (revasClient: RevasClient, pageSize: number, search: string) {
    super(pageSize, search)
    this.revasClient = revasClient
  }

  async asyncRequestPage (token: string): Promise<[Page<Resource>, string]> {
    if (this.revasClient === null) {
      throw new Error('client is null')
    }

    const resources: Resource[] = []
    const resourceResponse = await this.revasClient.asyncRevasPost('/humans/humans.ListResources/', {
      pageSize: this.pageSize,
      pageToken: token,
      search: this.search
    })

    if (resourceResponse.resources.length > 0) {
      resourceResponse.resources.forEach((resource: Resource) => {
        resources.push(resource)
      })

      let nextPageToken = resourceResponse.nextPageToken

      while (nextPageToken !== '') {
        const response = await this.revasClient.asyncRevasPost('/humans/humans.ListResources/', {
          pageSize: this.pageSize,
          pageToken: nextPageToken,
          search: this.search
        })
        response.resources.forEach((resource: Resource) => {
          resources.push(resource)
        })
        nextPageToken = response.nextPageToken
      }

      const newPage = new Page<Resource>()
      newPage.items = resources

      return [newPage, '']
    } else {
      return [new Page<Resource>(), '']
    }
  }

  clone (): PaginationState<Resource> {
    if (this.revasClient === null) {
      throw new Error('revas client is null')
    }
    const p = new ListInfiniteResourcePagination(this.revasClient, this.pageSize, this.search)
    p.tokens = this.tokens
    p.currentPage = this.currentPage
    return p
  }
}
